(() => {
  'use strict';
  const cfg = window.WHITEHOLE || {};
  const safeParse = (value, fallback) => { try { return JSON.parse(value); } catch (_) { return fallback; } };
  const getStore = (key, fallback = []) => safeParse(localStorage.getItem(key), fallback);
  const setStore = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const normalizeUrl = (url = '') => {
    if (!url) return '#';
    try { const parsed = new URL(url, window.location.origin); return parsed.origin === window.location.origin ? parsed.pathname + parsed.search + parsed.hash : parsed.href; }
    catch (_) { return '#'; }
  };
  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const format = cfg.moneyFormat || '${{amount}}';
    const fixed = amount.toFixed(2);
    const noDecimals = Math.round(amount).toString();
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, fixed);
  };
  class RecentProducts {
    constructor() {
      this.key = 'whitehole_recent_v2';
      this.max = Math.max(4, Number(cfg.recentlyViewedLimit || 8));
      this.captureCurrent(); this.renderAll(); this.bind();
    }
    read() { return getStore(this.key, []).filter(item => item && item.handle).slice(0, this.max); }
    captureCurrent() {
      this.currentHandle = '';
      const node = document.querySelector('[data-wh-current-product]');
      if (!node) return;
      const current = safeParse(node.textContent, null); if (!current?.handle) return;
      this.currentHandle = current.handle;
      const items = this.read().filter(item => item.handle !== current.handle); items.unshift(current); setStore(this.key, items.slice(0, this.max));
    }
    bind() {
      document.addEventListener('click', event => {
        const remove = event.target.closest('[data-wh-recent-remove]'); if (!remove) return;
        const items = this.read().filter(item => item.handle !== remove.dataset.whRecentRemove); setStore(this.key, items); this.renderAll();
      });
    }
    card(item) {
      const image = (item.image || cfg.placeholderImage) ? `<img src="${escapeHTML(normalizeUrl(item.image || cfg.placeholderImage))}" alt="${escapeHTML(item.title)}" width="600" height="600" loading="lazy">` : '';
      return `<article class="wh-memory-card"><a class="wh-memory-card__image" href="${escapeHTML(normalizeUrl(item.url))}">${image}</a><div class="wh-memory-card__content"><h3><a href="${escapeHTML(normalizeUrl(item.url))}">${escapeHTML(item.title)}</a></h3><div class="wh-memory-card__meta"><span class="wh-memory-card__price">${escapeHTML(formatMoney(item.price))}</span><button type="button" class="wh-memory-card__remove" data-wh-recent-remove="${escapeHTML(item.handle)}">Remove</button></div></div></article>`;
    }
    renderAll() {
      const items = this.read();
      document.querySelectorAll('[data-wh-recent-section]').forEach(section => {
        const grid = section.querySelector('[data-wh-recent-grid]'); const empty = section.querySelector('[data-wh-recent-empty]');
        const limit = Math.max(2, Number(section.dataset.limit || 4)); if (!grid || !empty) return;
        const visible = items.filter(item => item.handle !== this.currentHandle).slice(0, limit); grid.innerHTML = visible.map(item => this.card(item)).join(''); grid.hidden = visible.length === 0; empty.hidden = visible.length > 0;
      });
    }
  }

  const initCountdowns = () => {
    document.querySelectorAll('[data-wh-countdown]').forEach(section => {
      const targetRaw = section.dataset.target?.trim(); if (!targetRaw) return;
      const target = new Date(targetRaw).getTime(); if (!Number.isFinite(target)) return;
      const update = () => {
        const delta = target - Date.now();
        if (delta <= 0) {
          section.querySelectorAll('[data-days],[data-hours],[data-minutes],[data-seconds]').forEach(node => node.textContent = '00');
          if (section.dataset.hideAfter === 'true' && !window.Shopify?.designMode) section.hidden = true;
          return false;
        }
        const d = Math.floor(delta / 86400000), h = Math.floor(delta / 3600000) % 24, m = Math.floor(delta / 60000) % 60, s = Math.floor(delta / 1000) % 60;
        const set = (selector, value) => { const node = section.querySelector(selector); if (node) node.textContent = String(value).padStart(2, '0'); };
        set('[data-days]', d); set('[data-hours]', h); set('[data-minutes]', m); set('[data-seconds]', s); return true;
      };
      if (update()) { const timer = setInterval(() => { if (!update()) clearInterval(timer); }, 1000); }
    });
  };

  const initBeforeAfter = () => document.querySelectorAll('[data-wh-before-after]').forEach(frame => {
    const range = frame.querySelector('[data-wh-before-after-range]'); if (!range) return;
    const update = () => frame.style.setProperty('--position', `${range.value}%`); range.addEventListener('input', update); update();
  });

  const initLooks = () => document.querySelectorAll('.wh-look').forEach(section => {
    const cards = [...section.querySelectorAll('[data-wh-look-card]')];
    section.addEventListener('click', event => {
      const hotspot = event.target.closest('[data-wh-look-target]'); if (!hotspot) return;
      cards.forEach(card => card.classList.toggle('is-active', card.id === hotspot.dataset.whLookTarget));
    });
  });

  const initLogoSliders = () => document.querySelectorAll('[data-wh-logo-slider]').forEach(slider => {
    if (slider.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const speed = Math.max(1800, Number(slider.dataset.speed || 5000));
    let timer;
    const run = () => { clearInterval(timer); timer = setInterval(() => {
      if (window.innerWidth >= 750 || document.hidden) return;
      const first = slider.firstElementChild; if (!first) return;
      const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).gap || 0);
      const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      slider.scrollTo({left: atEnd ? 0 : slider.scrollLeft + step, behavior:'smooth'});
    }, speed); };
    slider.addEventListener('pointerenter', () => clearInterval(timer)); slider.addEventListener('pointerleave', run); run();
  });

  const initUtilities = () => {
    const back = document.querySelector('[data-wh-back-to-top]');
    if (back) {
      back.hidden = false;
      const update = () => back.classList.toggle('is-visible', window.scrollY > 650);
      window.addEventListener('scroll', update, {passive:true}); back.addEventListener('click', () => window.scrollTo({top:0,behavior:'smooth'})); update();
    }
    const cookie = document.querySelector('[data-wh-cookie-notice]');
    if (cookie) {
      const dismissed = localStorage.getItem('whitehole_cookie_notice_v1') === 'dismissed'; cookie.hidden = dismissed;
      cookie.querySelector('[data-wh-cookie-dismiss]')?.addEventListener('click', () => { localStorage.setItem('whitehole_cookie_notice_v1','dismissed'); cookie.hidden = true; });
    }
  };

  const init = () => {
    new RecentProducts(); initCountdowns(); initBeforeAfter(); initLooks(); initLogoSliders(); initUtilities();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', () => { initCountdowns(); initBeforeAfter(); initLooks(); initLogoSliders(); });
})();
